import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import type { NatconArticle } from '../../Kentico/DigitalDesign/natcon_article';
import withContext from '../../ContextAPI/Context_HOC';
import NatConProxy from '../Utilities/NatConProxy';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-flexbox-grid';
import NatConCarousel2025 from './NatConCarousel2025';
import { byPinnedThenByDatePublished } from '../Utilities/NatConUtils';

const NatCon2025: FunctionComponent<{
  context: { natConProxy: NatConProxy };
}> = ({ context: { natConProxy } }) => {
  const [natconArticles, setNatconArticles] = useState([] as NatconArticle[]);
  useEffect(() => {
    const natConProxyGetNatConsSubscription = natConProxy.getNatCons('national_convention_2025').subscribe((x) => {
      const articlesSorted = [...x].sort(byPinnedThenByDatePublished);
      setNatconArticles(articlesSorted);
    });
    return () => natConProxyGetNatConsSubscription.unsubscribe();
  }, [natConProxy]);
  return (
    <div>
      <NatConCarousel2025 />
      <h1>117th US Bahá’í National Convention: April 24 – 27, 2025</h1>
      <h4>
        More photos from the Convention are{' '}
        {/* <a href="https://www.flickr.com/photos/bahaius/collections/72157722768523226/" target="_blank" rel="noopener noreferrer">
          Flickr
        </a> */}
        coming soon.
      </h4>
      <h4>
        Below are stories on the Convention from <em>The American Bahá’í</em>
      </h4>
      <hr />
      <Row>
        <Col sm={12} md={8}>
          {natconArticles.map((article, index) => {
            const introBlurbHtml = article.introBlurb.resolveHtml();
            const intro = parse(introBlurbHtml);
            const thumbnailUrl = article.articleThumbnail?.value?.length > 0 ? article.articleThumbnail.value[0].url : null;
            const thumbnailDescription =
              article.articleThumbnail?.value?.length > 0 ? article.articleThumbnail.value[0].description : '';
            return (
              <Fragment key={index + Date.now() + article.urlSlug.value + article.system.id}>
                <Link
                  to={{ pathname: `/news/natcon-2025/${article.system.codename}` }}
                  className="plain-link plain-hover"
                  key={index}
                  data-testid={`natconarticle${index}`}
                >
                  <Row>
                    <Col sm={3}>
                      {thumbnailUrl ? <img src={thumbnailUrl} alt={thumbnailDescription} className="thumbnail-img" /> : null}
                    </Col>
                    <Col sm={9}>
                      <h3>{article.baseTitle.value}</h3>
                      <div>{intro}</div>
                    </Col>
                  </Row>
                </Link>
                <hr />
              </Fragment>
            );
          })}
        </Col>
        <Col sm={12} md={4}>
          <div className="sidebar-box">
            <h4>Resources</h4>
            <ul>
              <li className="small-bottom-padding">
                <Link to="/nine-year-plan">Nine Year Plan documents</Link>
              </li>
              <li className="small-bottom-padding">
                <Link to="/guidance/uhj/ridvan-2025-message-from-the-supreme-body-2025/ridvan-2025-message-from-the-supreme-body-2025">
                  Ridván 2025 Message from the Supreme Body
                </Link>
              </li>
              <li className="small-bottom-padding">
                <a href="https://bahai-web.s3.us-east-1.amazonaws.com/messages/AnnualReports/Ridvan+Annual+Report+2025.pdf">
                  Ridván 2025 Annual Report
                </a>
              </li>
            </ul>
            <hr />
            <h4>Treasurer’s Report</h4>
            <iframe
              title="Treasurer’s Report"
              src="https://player.vimeo.com/video/1078827311?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              width="100%"
              height="166"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
            <hr />
            <h4>National Convention Coverage Archives</h4>
            <ul className="plain-list">
              <li>
                <Link to="/news/natcon-2024">National Convention 2024</Link>
              </li>
              <li>
                <Link to="/news/natcon-2023">National Convention 2023</Link>
              </li>
              <li>
                <Link to="/news/natcon-2022">National Convention 2022</Link>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default withContext(NatCon2025);
